module.exports = __webpack_public_path__ + "img/icon-search.9f393dc3.svg";